<template>

  <div id="bg">

    <div id="logo"></div>

    <div id="content">

      <h2>{{ getTranslation('qr_prompt') }}<p class="whatsapp-logo">.</p></h2>

      <center>
        <qrcode :value="qr_deeplink" :options="{ width: 260 }" tag="img"></qrcode>
      </center>

      <p id="privacy-policy">Learn more about our privacy policy <a href="https://outsidevoice.io/privacy">here</a></p>
      <img id="copyright" src="../assets/copyright.svg">

    </div>

  </div>

</template>

<script>

import { translations } from '../services/translations.js';
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {

  name: 'surveyQR',

  props: {},

  components: {
    'qrcode': VueQrcode
  },

  computed: {

    language() {
      return this.$route.query.lang || 'en';
    },

    qr_deeplink() {

      let shortcode = this.$route.query.code;
      let uid = this.$route.query.uid;
      let phone = this.$route.query.phone;

      if (shortcode) {

        let bot_number = phone || '13513000071';

        // Use whatsapp deeplink if the study is in english and doesn't include an external uid;
        // TODO: Allow support for external uid's in whatsapp deeplink
        // TODO: Allow support for custom starting messages - Need to pass it in from Voic first
        if ((this.language === 'en' || !this.language) && !uid) {
          return `https://api.whatsapp.com/send?phone=${bot_number}&text=%28Send%20this%20message%29%20I%20would%20like%20to%20take%20survey%20code%3a%20${shortcode}&source=&data=&app_absent=`;

        // If survey is not in English or includes an external uid, route to normal voic.co link on mobile.
        } else {
          let url = `https://voic.co/${shortcode}`;
          if (uid) {
            url += `?uid=${uid}`;
          };
          return url;
        };

      } else {
        return null;
      };

    }

  },

  methods: {

    getTranslation(key) {
      return translations(key, this.language);
    },

  },

  created() {
    let code = this.$route.query.code || 'none';
    analytics.page('QR', { shortcode: code });
  }

}
</script>


<style lang="scss" scoped>

#bg{
  display: block;
  width: 100%;
  min-height: 100%;
  height: auto;
  background-image:
    url("../assets/landing-world-bg.png"),
    url("../assets/landing-whatsapp-bg.png");
  background-position:
    center,
    top left;
  background-repeat:
    no-repeat,
    repeat;
  overflow: hidden;
}

#logo{
  position: fixed;
    top: 40px;
    left: 50%;
  width: 180px;
  height: 30px;
  transform: translateX(-90px);
  background-image: url("../assets/logo.svg");
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 100%;
}

#content{

  display: block;
  width: 500px;
  height: 100%;
  margin: 0 auto;
  margin-top: 180px;
  font-family: 'Montserrat', sans-serif;

  h2{
    color: white;
    font-size: 22px;
    font-weight: 600;
    line-height: 38px;
    text-align: center;
    margin-bottom: 40px;
    .whatsapp-logo{
      display: inline;
      padding: 18px;
      background-image: url("../assets/whatsapp-logo.svg");
      background-size: 28px;
      background-position: center;
      background-repeat: no-repeat;
      margin: 0px;
    }
  }

  // QR Code
  img{
    display: block;
  }

}

#privacy-policy{
  position: fixed;
    bottom: 55px;
    left: 50%;
  width: 300px;
  color: white;
  transform: translateX(-150px);
  opacity: .8;
  a{
    color: white;
    font-weight: 700;
  }
}

#copyright{
  position: fixed;
    bottom: 25px;
    left: 50%;
  width: 150px;
  transform: translateX(-75px);
  opacity: .8;
}



// Mobile Styles
@media only screen
and (min-device-width: 320px)
and (max-device-width: 480px) {

#wrapper{
  width: 88%;
  padding-top: 40px;
}

#logo{
  display: none;
}

#content{
  width: 85%;
  margin-top: 50px;

  #ov-friends{
    width: 200px;
    height: 120px;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  h2{
    font-size: 15px;
    width: 80%;
    margin: 0 auto;
    margin-bottom: 20px;
    line-height: 20px;
  }

}

}

</style>
